import * as React from "react";
import { Card } from "@mantine/core";
import { HomeLink } from "../common/Links";

export const NotFound404: React.FunctionComponent = ({}) => (
  <Card
    style={{
      width: "fit-content",
      margin: "100px auto 0 auto",
    }}
    padding="xl"
  >
    <h2>404</h2>
    <p>
      You might be lost, click{" "}
      <HomeLink style={{ textDecoration: "underline" }}>here</HomeLink> to go
      home
    </p>
  </Card>
);

export const NotAuthorized: React.FunctionComponent = ({}) => (
  <Card
    style={{
      width: "fit-content",
      margin: "100px auto 0 auto",
    }}
    padding="xl"
  >
    <h2>Not allowed here</h2>
    <p>
      You're missing the required permissions to be here, click{" "}
      <HomeLink style={{ textDecoration: "underline" }}>here</HomeLink> to go
      home
    </p>
  </Card>
);
